// Auto-generated from container.json
export default {
  "tagName": "ui-container"
};
